import { KatStatusindicator } from "@amzn/katal-react";
import classnames from "classnames";
import classNames from "classnames";
import React, { type FC } from "react";
import { useTranslation } from "react-i18next";
import {
  type StatusIndicator,
  ValidationRuleSeverity,
} from "src/api/interfaces/document_validation";
import Field from "src/components/Field/Field";
import {
  DEFAULT_TRANSLATION_CONFIG,
  DEFAULT_TRANSLATION_NS,
} from "src/components/TranslatedField/TranslationKey";
import styles from "src/styles.module.scss";
import { getTranslatedValue } from "src/utils";

const INFO_TYPE = "information";
const ERROR_TYPE = "error";

const SEVERITY_TYPE_INFORMATION_TEXT =
  "aic_rule_severity_RuleSeverityValue_information_text_value";
const SEVERITY_TYPE_INFORMATION_TEXT_SEVERITY_KEY = "RuleSeverityValue";

const VALIDATION_RULE_SEVERITY_TO_STATUS_INDICATOR_TYPE: Map<
  ValidationRuleSeverity,
  StatusIndicator
> = new Map([
  [
    ValidationRuleSeverity.CRITICAL,
    { statusType: ERROR_TYPE, style: styles.status_critical },
  ],
  [
    ValidationRuleSeverity.ERROR,
    { statusType: ERROR_TYPE, style: styles.status_serious },
  ],
  [
    ValidationRuleSeverity.INFO,
    { statusType: ERROR_TYPE, style: styles.status_information },
  ],
  [
    ValidationRuleSeverity.SEVERE,
    { statusType: ERROR_TYPE, style: styles.status_serious },
  ],
  [
    ValidationRuleSeverity.WARNING,
    { statusType: ERROR_TYPE, style: styles.status_minor },
  ],
]);
const ValidationSeverityDescriptionItem: FC<
  ValidationSeverityDescriptionItemProps
> = ({ severityType }) => {
  const { t } = useTranslation(
    DEFAULT_TRANSLATION_NS,
    DEFAULT_TRANSLATION_CONFIG
  );
  const translatedSeverityTypeName = getTranslatedValue(
    severityType.valueOf(),
    t
  );
  const informationText = getTranslatedValue(
    SEVERITY_TYPE_INFORMATION_TEXT.replace(
      SEVERITY_TYPE_INFORMATION_TEXT_SEVERITY_KEY,
      severityType.valueOf().toLowerCase()
    ),
    t
  );

  const statusIndicatorType: StatusIndicator =
    VALIDATION_RULE_SEVERITY_TO_STATUS_INDICATOR_TYPE.get(severityType) || {
      statusType: INFO_TYPE,
    };
  return (
    <div
      className={classnames(
        styles.display_flex,
        styles.flex_direction_row,
        styles.mt_16
      )}
    >
      <div className={classnames(styles.flex_initial, styles.min_w_15)}>
        <KatStatusindicator
          label={translatedSeverityTypeName}
          variant={statusIndicatorType.statusType}
          className={classNames(
            styles.capitalizedText,
            statusIndicatorType.style
          )}
        />
      </div>
      <div className={classnames(styles.flex_initial, styles.min_w_85)}>
        <Field value={informationText} />
      </div>
    </div>
  );
};

export type ValidationSeverityDescriptionItemProps = {
  severityType: ValidationRuleSeverity;
};

export default ValidationSeverityDescriptionItem;
